var Curriculog = Curriculog || {};
Curriculog.ProposalToolbox = Curriculog.ProposalToolbox || {};

Curriculog.ProposalToolbox.ProposalLookupItem = (function ($, _, Backbone, ProposalLookupItem) {

	ProposalLookupItem = Backbone.View.extend({

		tagName: 'li',
		className: 'proposal-lookup-summary',

		events: {},

		initialize: function(options) {
			this.user = options.user;
			this.params = options.params;

			if (! _.isEmpty(this.model)) {
				this.render();
				this.setElement('#detail-' + this.model.get('id'));
			}
		},

		render: function() {
			return nunjucks.render('ProposalToolbox/proposalLookupItem.html',
				{
					proposal: this.model.attributes,
					user: this.user.attributes,
					level: this.params.domParams.get('level'),
          cui_enabled: this.params.cui_enabled
				}
			);
		},

	});

	return ProposalLookupItem;

})($, _, Backbone, Curriculog.ProposalListItem || {});
